export default __webpack_public_path__ + "static/media/solana-icon.f98d6280.svg";